import React from "react";
import Verifications from "./Verifications";

export default function DeliveryPartnerVerifications() {
  return <Verifications segment="delivery_partner" title="Delivery Verification" description="Non-commercial bike partners for food delivery." />;
}
